import React from "react";
import {
  Grid,
  Card,
  makeStyles,
  CardContent,
  Typography,
  Box,
} from "@material-ui/core";
import numeral from "numeral";
import { KPIComparativo, KPIComparativoProps } from "./KPIComparativo";

const useStyles = makeStyles((theme) => ({
  root: {
    height: "100%",
  },
}));

export interface CardKPIProps {
  nome: string;
  indicador: IndicadorProps;
  comparativo?: KPIComparativoProps;
}

export interface IndicadorProps {
  prefixo?: string;
  valor: number;
  formatacao: string;
  sufixo?: string;
}

export const CardKPI = (props: CardKPIProps) => {
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardContent>
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item>
            <Typography color="textSecondary" gutterBottom variant="h6">
              {props.nome}
            </Typography>
            <Typography color="textPrimary" variant="h5">
              {(props.indicador.prefixo ? props.indicador.prefixo + " " : "") +
                numeral(props.indicador.valor).format(
                  props.indicador.formatacao,
                ) +
                (props.indicador.sufixo ? " " + props.indicador.sufixo : "")}
            </Typography>
          </Grid>
        </Grid>
        <Box
          mt={2}
          display={props.comparativo ? "flex" : "none"}
          alignItems="center"
        >
          {props.comparativo ? (
            <KPIComparativo {...props.comparativo} />
          ) : (
            <></>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
